import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "item-1",
  question: "תוך כמה זמן ניתן להשיג מטפל סיעודי לבית?",
  answer: "אנו מתחייבים למציאת פתרון והשמת מטפל סיעודי מקצועי בביתכם תוך 5 שעות בלבד מרגע הפנייה, בכל רחבי הארץ."
}, {
  id: "item-2",
  question: "האם המטפלים שלכם עוברים הכשרה רפואית?",
  answer: "כל המטפלים בצוות שלנו עוברים סינון קפדני והכשרות מקצועיות בתחומי הסיעוד, העזרה הראשונה והטיפול האישי, כדי להבטיח את רמת הטיפול הגבוהה ביותר ליקיריכם."
}, {
  id: "item-3",
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "בהחלט. המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד מלאים גם בשבתות, חגים ובמצבי חירום הדורשים מענה מיידי."
}, {
  id: "item-4",
  question: "איך מתבצע תהליך ההתאמה בין המטפל למטופל?",
  answer: "אנו מבצעים אבחון טלפוני מהיר של צרכי המטופל, מצבו הרפואי והעדפותיו האישיות, ומתאימים לו את המטפל בעל הניסיון הרלוונטי ביותר מתוך המאגר הזמין שלנו."
}, {
  id: "item-5",
  question: "האם אתם מסייעים בהגשת תביעות לביטוח הלאומי?",
  answer: "כן, הצוות המקצועי שלנו מלווה את המשפחות בכל הבירוקרטיה הנדרשת מול המוסד לביטוח לאומי וחברות הביטוח למיצוי זכויות הסיעוד שלכם."
}, {
  id: "item-6",
  question: "מה קורה אם המטפל אינו מתאים לנו?",
  answer: "שביעות הרצון שלכם היא בראש סדר העדיפויות שלנו. במידה ואין התאמה, אנו נדאג להחלפת המטפל באופן מיידי וללא עלות נוספת עד למציאת השילוב המושלם."
}, {
  id: "item-7",
  question: "האם השירות ניתן גם בבתי חולים?",
  answer: "כן, אנו מספקים שירותי השגחה וסיעוד פרטיים גם במהלך אשפוז בבתי חולים, כדי להעניק למטופל יחס אישי וצמוד שאינו תמיד מתאפשר על ידי הצוות המחלקתי."
}];
export default function FaqAccordion() {
  return <section data-section-id="260694" id="שאלות-נפוצות" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto max-w-3xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary md:text-4xl">
            שאלות נפוצות על שירותי סיעוד מיידיים
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-none bg-card rounded-lg px-2 md:px-4 shadow-md">
              <AccordionTrigger className="py-5 px-4 hover:no-underline text-right font-default text-lg font-semibold text-card-foreground [&>svg]:bg-accent [&>svg]:p-1.5 [&>svg]:rounded-md [&>svg]:size-7 [&>svg]:text-accent-foreground [&>svg]:shadow-sm">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-6 text-base text-muted-foreground font-default leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}